// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"7d7a1762","453":"70d4c0ee","504":"88b525cf"}[chunkId] + ".chunk.js";
};